/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".copyright-background[_ngcontent-%COMP%]{min-height:94px}@media (min-width:576px) and (max-width:732px){.copyright-background[_ngcontent-%COMP%]{min-height:120px;height:auto}}.copyright-links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{font-size:15px}p[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
